import { createFileRoute } from "@tanstack/react-router";

import { PageError } from "@/components/dashboard/page-state";
import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { PayrollRunPage } from "@/pages/dashboard/payroll-runs/run";

export const Route = createFileRoute("/_main/dashboard/payroll-runs/$month")({
  component: PayrollRunRoute,
});

function PayrollRunRoute() {
  const { month } = Route.useParams();
  if (!/^\d{4}-\d{2}$/.test(month)) return <PageError error={null} />;
  return (
    <RequirePermission action="payroll.read">
      <PayrollRunPage month={month} />
    </RequirePermission>
  );
}
